<template>
  <div class="list" @click="$emit('click', user)">
   
    <div class="item">
      
      <span>{{ user.客户姓名 }} </span>
      <span>注册时间:{{ RegisterTime() }}</span>
       <span  v-if="user.扫客备注时间" class="state">
         {{user.扫客状态}}
      </span>
      <a
        :href="'tel:' + user.客户电话"
        class="calltel"
        v-else
        @click="calltel()"

      >
        <van-icon name="phone-o" />
      </a>
     
    </div>
    <!-- <div class="item">
      <span>最近回访：{{ user.跟办顾问姓名 }}[{{ user.跟办顾问 }}]</span>
    </div> -->
    <div class="item">
      <span>跟办顾问：{{ user.跟办顾问姓名 }}[{{ user.跟办顾问 }}]</span>
    </div>
    <div class="item" v-if="user.扫客备注">
      <span>扫客备注：{{ user.扫客备注 }}</span>
    </div>
    <div class="oper" v-if="user.扫客呼叫时刻 && user.扫客备注时间==undefined ">
      <van-field v-model="user.扫客备注" label="备注" placeholder="请输入备注信息" />
      <van-row>
        <van-col span="12"
          ><van-button
            type="default"
            plain
            @click="SaveInfo('已放弃')"
            round
            block
            >放弃</van-button
          >
        </van-col>

        <van-col span="12">
          <van-button type="info" plain @click="SaveInfo('已认领')" round block
            >认领</van-button
          >
        </van-col>
      </van-row>

      <!-- <span  :class="['btn',fangqi?'dark':'']" @click="Fangqi(user)"  v-if="renling==false ">放弃</span>
      <span v-else class="custom-tel">{{user.客户电话}}</span>
      <span :class="['btn',renling?'green':'']" @click="Renling(user)"  v-if="renling==false && fangqi==false" >认领</span> -->
    </div>
    <!-- <div class="item">
      <span>注册:{{ RegisterTime() }} 11 </span>
    
    </div> -->
    <!-- <van-cell
        :title="user.客户姓名+' '+user.客户电话"
        :value="RegisterTime(user)"
        :label="CallbackTime(user)"
        @click="$emit('click', user) "
      /> -->
  </div>
</template>
<script>
import { parseTime } from "@/utils/date";

export default {
  name: "record",
  props: ["user"],
  methods: {},
  data() {
    return {
      // fangqi: false,
      // renling: false,

      备注: "",
    };
  },
  components: {},
  methods: {
    calltel() {
      this.user.扫客备注=""
      this.$set(this.user,"扫客呼叫时刻",new Date().getTime().toString())
      
    },
    SaveInfo(state) {
      if (this.user.扫客备注 == "") {
        this.$toast({
          message: "请填写备注",
        });
        return;
      }
      this.user.扫客状态 = state;
       this.$set(this.user,"扫客备注时间",new Date().getTime().toString())
    
      this.$request.customerPublicSave(this.user).then((res) => {
        console.log(res);
      });
    },
    // Fangqi(user) {
    //   this.user["已放弃"].push(this.$store.state.account);
    //   this.$request.customerPublicSave(this.user).then((res) => {
    //     console.log(res);
    //     this.fangqi = true;
    //     this.renling = false;
    //   });
    // },
    // Renling(user) {
    //   this.user["已认领"] = this.$store.state.account;
    //   this.$request.customerPublicSave(this.user).then((res) => {
    //     console.log(res);
    //     this.renling = true;
    //     this.fangqi = false;
    //   });
    // },
    RegisterTime() {
      return parseTime(this.user._createtime, "{y}-{m}-{d}");
    },
    CallbackTime() {
      if (this.user.回访记录)
        return parseTime(
          this.user.回访记录[0].回访时刻,
          "回访： {y}-{m}-{d} {h}:{i}"
        );
    },
  },
};
</script>
<style scoped lang="less">
.dark{
  background-color: darkgray;
}
.green{
  background-color: darkgreen;
}
.oper{
  border: 1px solid lightgray;
  font-size:10px;
  padding: 3px;
}
.center{
  text-align: center;
}
.state{
  float: right;
  width: 60px;
  
  text-align: center;
  line-height: 30px;
  padding: 0 5px;
  font-size: 12px;
  background-color: goldenrod;
  color: white;
  border-radius: 5px;
}

.calltel{
  float: right;
  width: 40px;

  text-align: center;
  line-height: 30px;
  padding: 0 5px;
  font-size: 14px;
  background-color: goldenrod;
  color: white;
  border-radius: 5px;
}
.list{
  margin:3px 6px;
  border: 1px solid lightgrey ;
  padding: 3px;
  border-radius: 3px;
}
.item{
  font-size: 12px;
}

.right{
  display: inline-block;
  width: 160px;
  float: right;
}
.btn{
  float: right;
  margin: 0 10px;
  font-size:14;
  line-height: 30px;
  width: 40px;
  display: inline-block;
  border-radius: 5px;
 border: 1px solid gray;
 text-align: center;
}
//////

.items {
  background: #fff;
  box-sizing: border-box;
  //padding: 5px;
  //margin-bottom: 5px;
}
.custom-address{
font-size: 10px;
padding-top: 0px;
padding-left: 30px;
}
.custom-tel{
font-size: 12px;
padding-top: 0px;
padding-left: 30px;
}
.recordItem {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  .icon,
  // .record {
  //   width: 30px;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  // }
  .icon {
    font-size: 18px;
  }
  // .record {
  //   width: 50px;
  //   color: #1989fa;
  // }
  // .message {
  //   flex: 1;
  //   //   display: flex;
  //   //   flex-direction: row;
  //   //   align-items: center;
  //   span {
  //     display: block;
  //     padding: 3px;
  //   }
  // }
}
</style>